import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import CompetenciesFunServices from "./CompetenciesFun.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCompetencyFun = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCYFUN,
      payload: true,
    });
    const resp = await CompetenciesFunServices.getCompetencyFun(filters);
    dispatch({
      type: actions.GET_COMPETENCYFUN,
      payload: {
        competenciesFun: resp.data.data,
        competenciesFunLength: resp.data.count,
      },

    });

    dispatch({
      type: actions.COMPETENCYFUN_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCYFUN_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCYFUN,
      payload: false,
    });
  }


};

export const getCompetency = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCY,
      payload: true,
    });
    const resp = await CompetenciesFunServices.getCompetency(filters);
    dispatch({
      type: actions.GET_COMPETENCY,
      payload: {
        competencies: resp.data.data,
        competenciesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.COMPETENCY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCY,
      payload: false,
    });
  }
};


export const getTasks = (params) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_TASK,
      payload: true
    });
    const resp = await CompetenciesFunServices.getTasks(params, 1);
    dispatch({
      type: actions.GET_TASKS,
      payload: {
        tasks: resp.data.data,
        tasksLength: resp.data.count
      }
    });
    dispatch({
      type: actions.TASK_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TASK_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TASK,
      payload: false
    });
  }
}
export const saveCompetencyFun =
  (data, setShowModal) => async (dispatch, getState) => {
    try {

      dispatch({
        type: actions.SAVE_LOADING_COMPETENCYFUN,
        payload: true,
      });
      const resp = await CompetenciesFunServices.saveCompetencyFun(data);

      debugger
      const { competenciesFun, competenciesFunLength } = getState().planCarreraCompetenciesFun;
      const _competenciesFun = [...competenciesFun, resp.data];
      dispatch({
        type: actions.GET_COMPETENCYFUN,
        payload: {
          competenciesFun: _competenciesFun,
          competenciesFunLength: competenciesFunLength + 1,

        },


      });

      dispatch({
        type: actions.FORM_FAIL,
        payload: "",

      })
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_COMPETENCYFUN,
        payload: false,
      });
    }
  };

export const editCompetencyFun =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {

      dispatch({
        type: actions.LOADING_COMPETENCYFUN,
        payload: true,
      });
      const resp = await CompetenciesFunServices.editCompetencyFun(id, data);

      const { competenciesFun, competenciesFunLength } = getState().planCarreraCompetenciesFun;
      competenciesFun[index] = resp.data;
      dispatch({
        type: actions.GET_COMPETENCYFUN,
        payload: {
          competenciesFun: competenciesFun,
          competenciesFunLength: competenciesFunLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COMPETENCYFUN,
        payload: false,
      });
    }
  };

export const deleteCompetencyFun = (id, index) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.LOADING_COMPETENCYFUN,
      payload: true,
    });
    await CompetenciesFunServices.deleteCompetencyFun(id);
    debugger
    const { competenciesFun, competenciesFunLength } = getState().planCarreraCompetenciesFun;
    competenciesFun.splice(index, 1);

    dispatch({
      type: actions.GET_COMPETENCYFUN,
      payload: {
        competenciesFun: competenciesFun,
        competenciesFunLength: competenciesFunLength - 1,
      },
    });
    dispatch({
      type: actions.COMPETENCYFUN_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.COMPETENCYFUN_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCYFUN,
      payload: false,
    });
  }
};
